import useUnleashFeatureFlag from 'react-scale/hooks/useUnleashFeatureFlag';
import { useMemo } from 'react';

const useQueryCompassFeatureFlags = (user: { _id: string }) => {
  const compassAdminFeatures =
    useUnleashFeatureFlag('compass-admin-features', { userId: user._id }, false) ||
    window.location.hostname === 'localhost';

  return useMemo(() => ({ compassAdminFeatures }), [compassAdminFeatures]);
};

export default useQueryCompassFeatureFlags;
